import React, { useState } from 'react'
import Fade from 'react-reveal/Fade'

import Layout from 'components/Layout'
import PageHero from 'components/UI/PageHero'
import ContactForm from 'components/UI/ContactForm'
import ResponsiveContainer from 'components/utils/ResponsiveContainer'

const Contact = () => {

    const [ displayForm, setDisplayForm ] = useState(true)
    return (
        <Layout floatingHeader={ true } pageTitle="Register" pageGroup="contact">
            <PageHero title="VC Registration" />
            <section>
                <ResponsiveContainer className="py-20 lg:py-32">
                    <div className="lg:w-9/12 lg:mx-auto">
                        <Fade>
                            <div className="mb-12">
                                <ContactForm displayForm={ displayForm } setDisplayForm={ setDisplayForm }/>
                            </div>
                            <p>For further information please contact us at</p>
                            <a href="mailto:info@jejala.id" className="text-primary font-bold text-4xl border-b border-solid border-red-500 border-opacity-10 md:text-6xl">info@jejala.id</a>
                        </Fade>
                    </div>
                </ResponsiveContainer>
            </section>
        </Layout>
    )
}

export default Contact
